// Chakra 
import { 
  Button,
  Flex, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';
import { textLang } from 'services/Lang';

const DeleteModal = ({handle, onOpen, isOpen, onClose}) => {
  return (
    	<> 
        <Modal isOpen={isOpen}>
          <ModalOverlay />
          <ModalContent className="modal__simple" 
              maxW={{ base: '330px' }} 
              style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
              
             
              <Box position="relative" p="24px" bg='white !important' textAlign="center">
                  <Text variant="title-lg">
                    {textLang('setting_modal_delete_header')}
                  </Text>

                  <Text variant="text-md" mt="8px">
                    {textLang('setting_modal_delete_text')}
                  </Text>

                  <Button variant="solid-md" mt="16px" onClick={onClose}>{textLang('back')}</Button>
                  <Button variant="button-md" mt="8px" onClick={() => { handle(); onClose(); }}>{textLang('confirm')}</Button>
                  
              </Box>

          </ModalContent>
        </Modal> 
      </>
  );
};

export default DeleteModal;